import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./rem";
import "./devTool";
import XesLoggerSDK from "@xes/xes_fe_log";
import { globalConfig, getUrlHost } from "./saasConfig/index.js";
import { Toast, Divider, Sticky, List, Popup } from "vant";
import { $$, getUrlParams } from "./utils/index";
Vue.config.productionTip = false;
Vue.prototype.$platform = getUrlHost();
Vue.prototype.$businessId = globalConfig[getUrlHost()]?.id;
Vue.prototype.$brand = globalConfig[getUrlHost()]?.brand;
Vue.prototype.$baseUrl = globalConfig[getUrlHost()]?.baseUrl;
Vue.prototype.$isLoginFree = getUrlParams()?.isLoginFree === "1"; // 是否免登录
Vue.prototype.$isInApp =
  /jzh/.test(navigator.userAgent) || /mobbyapp/i.test(navigator.userAgent); // 是否学而思网校app或者小班app内
Vue.prototype.$$ = $$;
Vue.use(Toast);
Vue.use(Divider);
Vue.use(Sticky);
Vue.use(List);
Vue.use(Popup);
Vue.use(XesLoggerSDK, {
  common: {
    eventid: "campaign",
  },
  hashchange: {
    open: false, // hashchange自动展现日志开关
    pvid: "hash",
    pageuid: {
      // 展现日志、交互日志pageuid路由映射
      home: "1", // 首页路由pageuid映射
      "home/choose": "2",
    },
  },
  appid: {
    //   正式环境
    "app.xueersi.com": {
      appid: process.env.VUE_APP_SECRET === "test" ? "1002735" : "1002863",
      appkey:
        process.env.VUE_APP_SECRET === "test"
          ? "219486cf0c669b0a5f6c4c5821d97eca"
          : "0cc5f51fe0521b687bda47c26fe0b9b9",
    },
    "app.classa-z.com": {
      appid: "1005624",
      appkey: "5f8b8e95df0a384291a4d495c88fcc31",
    },
  },
});
new Vue({
  router,
  store,
  render: (h) => h(App),
  async mounted() {
    // 如果需要本地mock请自行打开注释
    if (process.env.NODE_ENV === "development") {
      //   require("./mock.js");
    }
  },
}).$mount("#app");
